import { Tooltip, TooltipProps } from '@mui/material';

export default function Hint(props: TooltipProps) {
  return (
    <Tooltip {...props} enterDelay={500} enterNextDelay={500}>
      {props.children}
    </Tooltip>
  );
}
